const tidalColorsLight = {
  cloudGray: {
    "50": "#FFFFFF",
    "100": "#F9FAFB",
    "200": "#F3F5F7",
    "300": "#EAEEF2",
    A400: "#2A323B",
    A500: "#1A1E23",
    A600: "#0E1013",
    A700: "#07080A"
  },
  deepPurple: {
    "50": "#EDE7F6",
    "100": "#D1C4E9",
    "200": "#B39DDB",
    "300": "#9575CD",
    "400": "#7E57C2",
    "500": "#673AB7",
    "600": "#5E35B1",
    "700": "#512DA8",
    "800": "#4527A0",
    "900": "#311B92",
    A100: "#B388FF",
    A200: "#7C4DFF",
    A400: "#651FFF",
    A700: "#6200EA"
  },
  jadeGreen: {
    "50": "#EDF8F3",
    "100": "#DCF2E7",
    "200": "#ABDEC6",
    "300": "#8AD1AF",
    "400": "#6BC69B",
    "500": "#47B882",
    "600": "#41A776",
    "700": "#31805B",
    "800": "#276547",
    "900": "#143324"
  },
  lightGreen: {
    "50": "#F1F8E9",
    "100": "#DCEDC8",
    "200": "#C5E1A5",
    "300": "#AED581",
    "400": "#A6CB72",
    "500": "#8BC34A",
    "600": "#7CB342",
    "700": "#689F38",
    "800": "#558B2F",
    "900": "#33691E",
    A100: "#CCFF90",
    A200: "#B2FF59",
    A400: "#76FF03",
    A700: "#64DD17"
  },
  lobsterRed: {
    "50": "#FBECE9",
    "100": "#F7DAD5",
    "200": "#ECA598",
    "300": "#E58270",
    "400": "#F1674F",
    "500": "#D63B1F",
    "600": "#A62E18",
    "700": "#892614",
    "800": "#621B0E",
    "900": "#3C1009"
  },
  oceanBlue: {
    "50": "#E1EBF7",
    "100": "#D4E3F3",
    "200": "#A1C1E6",
    "300": "#699DD7",
    "400": "#4383CC",
    "500": "#1565C0",
    "600": "#11539D",
    "700": "#0E4686",
    "800": "#002D5C",
    "900": "#061C35",
    A100: "#64ACFF",
    A200: "#3E98FF",
    A700: "#2B6AB2"
  },
  pink: {
    "50": "#FCE4EC",
    "100": "#F8BBD0",
    "200": "#F48FB1",
    "300": "#F06292",
    "400": "#EC407A",
    "500": "#E91E63",
    "600": "#D81B60",
    "700": "#C2185B",
    "800": "#AD1457",
    "900": "#880E4F",
    A100: "#FF80AB",
    A200: "#FF4081",
    A400: "#F50057",
    A700: "#C51162"
  },
  purple: {
    "50": "#F3E5F5",
    "100": "#E1BEE7",
    "200": "#CE93D8",
    "300": "#BA68C8",
    "400": "#AB47BC",
    "500": "#9C27B0",
    "600": "#8E24AA",
    "700": "#7B1FA2",
    "800": "#6A1B9A",
    "900": "#4A148C",
    A100: "#EA80FC",
    A200: "#E040FB",
    A400: "#D500F9",
    A700: "#AA00FF"
  },
  seafoamTeal: {
    "50": "#E7F5F6",
    "100": "#CFEAED",
    "200": "#B8E0E4",
    "300": "#9FD5DB",
    "400": "#6FBFC8",
    "500": "#53B3BE",
    "600": "#0F95A4",
    "700": "#0B707B",
    "800": "#074A52",
    "900": "#042529"
  },
  skyBlue: {
    "50": "#ECF5FF",
    "100": "#DBECFF",
    "200": "#A7D0FF",
    "300": "#84BDFF",
    "400": "#64ACFF",
    "500": "#3E98FF",
    "600": "#337DD1",
    "700": "#2B6AB2",
    "800": "#22548C",
    "900": "#112A47"
  },
  slateBlueGray: {
    "50": "#EBEDEF",
    "100": "#D3D7DC",
    "200": "#BAC1C8",
    "300": "#A1ACB4",
    "400": "#8996A1",
    "500": "#70808D",
    "600": "#586A7A",
    "700": "#3F5466",
    "800": "#273E53",
    "900": "#0E283F",
    A700: "#091B2A"
  },
  sunnyYellow: {
    "50": "#FEF8E9",
    "100": "#FEF2D4",
    "200": "#FCDF96",
    "300": "#FBD36D",
    "400": "#FAC748",
    "500": "#F9BA1B",
    "600": "#CC9816",
    "700": "#AE8212",
    "800": "#89660F",
    "900": "#453408"
  }
};
export {
  tidalColorsLight
};
//# sourceMappingURL=tidalColorsLight.js.map
